import { useRunBuild } from '@/shell/RunBuildContext';
import { generalGuardrailsOf, isBlocked, launchBlockOf, readLaunchSchema } from './runBuildModel';
import { useClearPreviewOnChange, useFocusFirstField, useRunBuildDefaults } from './useRunBuildEffects';
import { useRunBuildActions, useRunBuildSession, useRunBuildValidation } from './useRunBuildActions';
import { useRunBuildFields } from './useRunBuildFields';
import { useRunBuildTarget } from './useRunBuildTarget';

/** Everything the Run build form renders and calls: fields, resolved target, launch schema, errors, preview and actions. */
export function useRunBuildForm() {
  const { preset, closeRunBuild } = useRunBuild();
  const fields = useRunBuildFields(preset);
  const target = useRunBuildTarget(preset, fields.values);
  const session = useRunBuildSession();
  const { errorFor, invalid } = useRunBuildValidation(target, fields.values, session);
  useRunBuildDefaults(target, fields);
  useClearPreviewOnChange(target, fields, session.setPreview);
  useFocusFirstField(target.loadingBasics);

  const launchBlock = launchBlockOf(target.launchData);
  const actions = useRunBuildActions({ target, values: fields.values, session, invalid, launchBlock, closeRunBuild });
  const schema = readLaunchSchema(target.launchData);
  const guardrails = target.launchData?.guardrails;
  const blocked = isBlocked(launchBlock, session.preview?.plan);
  return { preset, closeRunBuild, fields, target, schema, guardrails, generalGuardrails: generalGuardrailsOf(guardrails), errorFor, problem: session.problem, preview: session.preview, launchBlock, blocked, count: target.selectedPlatforms.length, ...actions };
}

export type RunBuildFormModel = ReturnType<typeof useRunBuildForm>;
